import React, { Component } from 'react';
import _ from 'lodash';
import UserCard from "./UserCard";
import { usersList } from '../actions/usersAction';
import {
  Typography,
  Theme,
  createStyles,
  WithStyles,
  withStyles,
  Card,
  CardContent,
  Grid,


} from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AddUserDialog from '../../user-management/components/AddUserDialog';
import ACL from '../../acl/components/ACL';

const styles = (theme: Theme) => createStyles({
  mb1x: {
    marginBottom: theme.spacing.unit,
  },
  ml1x: {
    marginLeft: theme.spacing.unit * 2,
  },
  mt1x: {
    marginTop: theme.spacing.unit * 2,
    MozBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
    WebkitBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
  },
  bold: {
    fontWeight: "bold",
  },
  gridFlex: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  avatar: {
    margin: 10,
    display: 'inline',
    width: 50,
    height: 50,
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
  },
  cardMain: {
    height: '100%',
    position: 'relative',
    overflowY: "auto",
    overflowX: "hidden",
    MozBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
    WebkitBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
  },
  UserCard: {
    padding: "5px !important",
    minHeight: '90px'
  },
  addUser: {
    cursor: 'pointer'
  },
  noContent: {
    margin: 0,
    position: "absolute",
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  }

});

interface DashboardUserlistProps extends WithStyles<typeof styles> {
  usersList: () => void,
  users: any,
}

interface DashboardUserlistState {
  addUserDialogOpen: boolean
}

class DashboardUserlist extends Component<DashboardUserlistProps, DashboardUserlistState> {

  constructor(props: DashboardUserlistProps) {
    super(props);
    this.state = {
      addUserDialogOpen: false,
    };

    this.userDialogEvent = this.userDialogEvent.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);

  }

  userDialogEvent(e: any) {
    this.setState({ addUserDialogOpen: false });
    this.props.usersList();
  }

  handleDialogClose(isShow: boolean, e: any) {
    this.setState({ addUserDialogOpen: isShow });
  }


  componentDidMount() {
    this.props.usersList();
  }

  render() {
    const { classes, users } = this.props;
    const { addUserDialogOpen } = this.state;

    return (
      <>
        <Card style={{overflow:"auto",height:"367px"}} className={`${classes.ml1x} ${classes.cardMain}`}>
          <CardContent>

            <Grid container  alignItems="center" spacing={16} className={classes.gridFlex}>
              <Grid item xs="auto">
                <Typography variant="h6" inline>User List ({users.length})</Typography>
              </Grid>

                <Grid item xs="auto">
                  <Typography variant="h6" className={classes.addUser} color="primary" onClick={this.handleDialogClose.bind(this, true)} inline>Add User</Typography>
                </Grid>
            </Grid>

            {
              users && users.length > 0 ?
                (_.map(users, user => (
                  <Card className={classes.mt1x} key={`userlist-${user._id}`}>
                    <CardContent className={classes.UserCard}>
                      <UserCard
                        name={`${user.firstName} ${user.lastName}`}
                        role={user.roles && user.roles.length > 0 ? user.roles[0].roleId.role : ''}
                        lastActivityAt={user.lastActivityAt}
                        imgSrc={user.profileImage}>
                      </UserCard>
                    </CardContent>
                  </Card>
                )))
                :
                <Typography className={classes.noContent} color="textSecondary">No Users</Typography>
            }


          </CardContent>
        </Card>

          <AddUserDialog
            dialogOpen={addUserDialogOpen}
            isDone={this.userDialogEvent}
            dialogCloseHandler={this.handleDialogClose.bind(this, false)}
          />
      </>
    )
  }
}


const mapStateToProps = (state: any) => ({
  users: _.get(state, 'dashboardData.users.list', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  usersList,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DashboardUserlist));